import { ScreeningProfessionalListResponse } from '../../types'
import { autoCapitalize } from '@conexasaude/front-utils'

class ScreeningProfessionalListMapper {
  toDomain(persistence: ScreeningProfessionalListResponse) {
    const formattedItems = persistence?.items?.map(item => {
      return {
        idPsychologist: item?.idPsicologo,
        reviews: {
          total: item?.avaliacoes?.total,
          stars: item?.avaliacoes?.estrelas,
        },
        psychologist: {
          id: item?.psicologo?.id,
          name: autoCapitalize(item?.psicologo?.nome),
          city: item?.psicologo?.cidade,
          state: item?.psicologo?.estado,
          crp: item?.psicologo?.crp,
          stateCrpCn: item?.psicologo?.estadoCrpCnx,
          description: item?.psicologo?.descricao,
          academicBackground: item?.psicologo?.formacao,
          flagProfessionalCorporate: item?.psicologo?.flagProfissionalCorporate,
          specialtyName: item?.psicologo?.nomeEspecialidade,
          idPhotoProfile: item?.psicologo?.idFotoPerfil,
          councilNumber: item?.psicologo?.numeroConselho,
          council: item?.psicologo?.conselho,
          title: autoCapitalize(item?.psicologo?.titulo),
          urlPhoto: item?.psicologo?.urlFoto,
          physiologicalApproach: item?.psicologo?.abordagem,
          triagistPsychologist: item?.psicologo?.psicologoTriagem,
        },
        session: {
          inPersonAmount: item?.sessao?.valorPresencial,
          paymentCurrency: item?.sessao?.moeda,
          time: item?.sessao?.tempo,
          amount: item?.sessao?.valor,
        },
      }
    })

    return {
      items: formattedItems,
      total: persistence?.total,
    }
  }
}

export default new ScreeningProfessionalListMapper()
